import { Button, Card, CardContent, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import NotConfigured from "../NotConfigured";

interface IMeetingProps {
  user: any;
  meetingContext: any;
  accessToken?: string;
  environment: string;
}

var botAdded = false;
const Meeting = ({ user, meetingContext, accessToken, environment }: IMeetingProps) => {
  const [msg, setMsg] = useState("");
  const [retry, setRetry] = useState(false);

  useEffect(() => {
    if (accessToken && meetingContext && !botAdded && user?.isConfigured) {
      botAdded = true;
      addMeetingBot();
    }
  }, [meetingContext, accessToken, user]);

  const addMeetingBot = async () => {
    try {
      setMsg("Requesting Meeting bot...");
      setRetry(false);
      const url = `/api/zoomapp/run-meeting-bot?meetingNumber=${meetingContext.meetingID}`;
      fetch(url, {
        headers: {
          "Authorization": `Bearer ${accessToken}`,
        },
      })
        .then((data) => {
          if (data.status === 200) {
            botAdded = true;
            setMsg(
              "meeting bot added, recording will start when permission is granted..."
            );
          } else {
            setMsg("failed to add meeting bot, please contact support...");
            setRetry(true);
            botAdded = false;
          }
        })
    } catch (error) {
      console.error(error);
      setMsg("failed to add Meeting bot, please contact support...");
      setRetry(true);
      botAdded = false;
    }
  };

  if (user?.isConfigured)
    return (
      <Card
        sx={{
          backgroundColor: "#171717",
          border: "1px solid #fff",
          borderRadius: "4px",
          color: "#fff",
          padding: "16px",
          margin: "10px",
          marginTop: "20px",
        }}
      >
        <CardContent>
          <Stack mt={2} spacing={1}>
            <Typography component="p" color="#fff">
              User: {user?.display_name}{" "}
              {user?.type === "1"
                ? " (Basic)"
                : user?.type === "2"
                  ? " (Licensed)"
                  : ""}
            </Typography>
            <Typography component="p" color="#fff">
              Email: {user?.email}
            </Typography>
          </Stack>
          <Stack mt={6} spacing={1}>
            <Typography component="p" color="#fff">
              Meeting Number: {meetingContext.meetingID}
            </Typography>
            <Typography component="p" color="#fff">
              Topic: {meetingContext.meetingTopic}
            </Typography>
          </Stack>
          <Stack spacing={2} mt={10} ml="25px" mr="25px">
            <Typography component="p" color="#fff">
              {msg}
            </Typography>
            {retry && (
              <Button color="error" onClick={() => addMeetingBot()}>
                Retry
              </Button>
            )}
          </Stack>
        </CardContent>
      </Card>
    );

    return (
      <NotConfigured user={user} />
    )
};
export default Meeting;
